import { c as _c } from "react/compiler-runtime";
import { Badge } from '@/shared/components/ui/common/Badge';
import { Button } from '@/shared/components/ui/common/Button';
import { TextField } from '@/shared/components/ui/common/TextField';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import type { SearchResult } from '@/types/home/types';
import { normalizeSearchQuery } from '@/shared/utils/searchNormalizer';
import { getSearchStatusConfig } from '../types/searchStatusConfig';
import { FeatherLoader, FeatherSearch, FeatherX } from '@subframe/core';
import { useRouter } from 'next/navigation';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { getDashboardSearch } from '../store';
import { selectHomeCount, selectSearchLoading, selectSearchResults } from '../store/selectors';
import { clearSearch, setSearchQuery } from '../store/slice';
import { DEFAULT_TYPE_CONFIG, DropdownBuscaProps, resolveRoute, TYPE_CONFIG } from '../types/search.types';
const DropdownBusca: React.FC<DropdownBuscaProps> = t0 => {
  const $ = _c(50);
  const {
    className
  } = t0;
  const dispatch = useAppDispatch();
  const router = useRouter();
  const results = useAppSelector(selectSearchResults);
  const resultsCount = useAppSelector(selectHomeCount);
  const loading = useAppSelector(selectSearchLoading);
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState("");
  const containerRef = useRef(null);
  let t1;
  if ($[0] !== dispatch || $[1] !== router) {
    t1 = result => {
      const route = resolveRoute(result);
      if (!route) {
        return;
      }
      setOpen(false);
      setValue("");
      dispatch(clearSearch());
      router.push(route);
    };
    $[0] = dispatch;
    $[1] = router;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleOpen = t1;
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const handleClickOutside = event => {
        if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
          setOpen(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    };
    t3 = [];
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[5] !== dispatch || $[6] !== value) {
    t4 = () => {
      const timer = setTimeout(() => {
        const normalized = normalizeSearchQuery(value);
        if (normalized.length >= 3) {
          dispatch(setSearchQuery(normalized));
          dispatch(getDashboardSearch(normalized));
          setOpen(true);
        } else {
          if (normalized.length === 0) {
            dispatch(clearSearch());
            setOpen(false);
          }
        }
      }, 500);
      return () => clearTimeout(timer);
    };
    t5 = [value, dispatch];
    $[5] = dispatch;
    $[6] = value;
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  useEffect(t4, t5);
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = event_0 => {
      setValue(event_0.target.value);
      if (normalizeSearchQuery(event_0.target.value).length >= 3) {
        setOpen(true);
      }
    };
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const handleChange = t6;
  let t7;
  if ($[10] !== value) {
    t7 = () => {
      if (normalizeSearchQuery(value).length >= 3) {
        setOpen(true);
      }
    };
    $[10] = value;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const handleFocus = t7;
  let t8;
  if ($[12] !== dispatch) {
    t8 = () => {
      setValue("");
      dispatch(clearSearch());
      setOpen(false);
    };
    $[12] = dispatch;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const handleClear = t8;
  const t9 = "relative ml-auto flex w-full max-w-full items-center justify-end gap-2 md:max-w-[80%] " + className;
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <FeatherSearch />;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== handleClear || $[16] !== value) {
    t11 = value ? <FeatherX className="text-subtext-color hover:text-default-font cursor-pointer" onClick={handleClear} /> : null;
    $[15] = handleClear;
    $[16] = value;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== handleFocus || $[19] !== value) {
    t12 = <TextField.Input placeholder={"Buscar por nome, n\xFAmero do processo, CPF ou CNPJ..."} value={value} onChange={handleChange} onFocus={handleFocus} className="w-full" />;
    $[18] = handleFocus;
    $[19] = value;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t11 || $[22] !== t12) {
    t13 = <TextField className="h-8 w-full flex-none [&>div]:focus-within:!border-neutral-200 [&>div]:focus-within:!ring-0" variant="filled" label="" helpText="" icon={t10} iconRight={t11}>{t12}</TextField>;
    $[21] = t11;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  const t14 = `absolute top-full left-0 z-50 mt-4 min-w-full transition-all duration-200 ease-in-out ${open ? "visible translate-y-0 opacity-100" : "invisible -translate-y-2 opacity-0"}`;
  const t15 = resultsCount || 0;
  let t16;
  if ($[24] !== t15) {
    t16 = <span className="text-caption-bold font-caption-bold text-subtext-color flex items-center gap-2">RESULTADOS DA BUSCA<span className="inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-neutral-200 px-1.5 text-xs font-semibold text-neutral-600">{t15}</span></span>;
    $[24] = t15;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== loading) {
    t17 = loading && <FeatherLoader className="text-subtext-color h-4 w-4 animate-spin" />;
    $[26] = loading;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== t16 || $[29] !== t17) {
    t18 = <div className="flex w-full items-center gap-2 px-2 py-1">{t16}{t17}</div>;
    $[28] = t16;
    $[29] = t17;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== handleOpen || $[32] !== results) {
    t19 = Array.isArray(results) && results.map(result_0 => <div key={result_0.id} className="flex w-full items-center gap-3 rounded-md bg-neutral-50 px-3 py-2 transition-colors hover:bg-neutral-100">{(TYPE_CONFIG[result_0.type] || DEFAULT_TYPE_CONFIG).icon}<div className="flex shrink-0 grow basis-0 flex-col items-start gap-1"><div className="flex items-center gap-2"><span className="text-body-bold font-body-bold text-default-font">{result_0.title}</span><Badge variant={(TYPE_CONFIG[result_0.type] || DEFAULT_TYPE_CONFIG).badgeVariant}>{(TYPE_CONFIG[result_0.type] || DEFAULT_TYPE_CONFIG).label}</Badge>{result_0.status && (() => {
            const statusConfig = getSearchStatusConfig(result_0.type, result_0.status);
            return <Badge variant={result_0.statusColor || statusConfig.variant}>{statusConfig.label}</Badge>;
          })()}</div><span className="text-caption font-caption text-subtext-color">{result_0.subtitle || result_0.description}{result_0.date && ` • ${result_0.date}`}</span></div><Button variant="brand-secondary" size="small" disabled={!resolveRoute(result_0)} onClick={() => handleOpen(result_0)}>Abrir</Button></div>);
    $[31] = handleOpen;
    $[32] = results;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== loading || $[35] !== results) {
    t20 = !loading && (!results || Array.isArray(results) && results.length === 0) && <div className="text-subtext-color text-caption w-full py-4 text-center">Nenhum resultado encontrado.</div>;
    $[34] = loading;
    $[35] = results;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== t19 || $[38] !== t20) {
    t21 = <div className="flex max-h-[400px] w-full flex-col items-start gap-2 overflow-y-auto">{t19}{t20}</div>;
    $[37] = t19;
    $[38] = t20;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] !== t18 || $[41] !== t21) {
    t22 = <div className="bg-default-background flex w-full flex-col items-start gap-2 rounded-md border border-solid border-neutral-200 px-2 py-2 shadow-md">{t18}{t21}</div>;
    $[40] = t18;
    $[41] = t21;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] !== t14 || $[44] !== t22) {
    t23 = <div className={t14}>{t22}</div>;
    $[43] = t14;
    $[44] = t22;
    $[45] = t23;
  } else {
    t23 = $[45];
  }
  let t24;
  if ($[46] !== t13 || $[47] !== t23 || $[48] !== t9) {
    t24 = <div ref={containerRef} className={t9}>{t13}{t23}</div>;
    $[46] = t13;
    $[47] = t23;
    $[48] = t9;
    $[49] = t24;
  } else {
    t24 = $[49];
  }
  return t24;
};
export default DropdownBusca;